import { createStore } from 'vuex'
import me from './modules/me'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    me,
  },
})
